import { useNavigate } from "react-router-dom";
import { accommodations } from "@/mocks/accommodations";

interface Props {
  currentId: number;
  area: string;
}

export default function RelatedAccommodations({ currentId, area }: Props) {
  const navigate = useNavigate();

  const related = accommodations
    .filter((a) => a.id !== currentId && (a.area === area || true))
    .slice(0, 4);

  return (
    <section className="mt-10 pt-8 border-t border-stone-100">
      <h2 className="text-lg sm:text-xl font-bold text-stone-900 mb-4 sm:mb-5">다른 추천 숙소</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
        {related.map((item) => (
          <button
            key={item.id}
            onClick={() => navigate(`/accommodation/${item.id}`)}
            className="text-left group cursor-pointer"
          >
            <div className="w-full h-28 sm:h-36 rounded-xl overflow-hidden bg-stone-100 mb-2">
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <p className="text-xs font-semibold text-stone-700 line-clamp-2 leading-snug mb-1">{item.name}</p>
            <div className="flex items-center gap-1 flex-wrap">
              <i className="ri-star-fill text-amber-400 text-xs"></i>
              <span className="text-xs text-stone-500">{item.rating}</span>
              <span className="text-xs text-stone-400">{item.price}/박</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
